const ShippingMethods = {
    parcelShops: {
        headline: "uiText.parcelShops.headline",
        select: "uiText.parcelShops.select",
        selectPickUpPoint: "uiText.parcelShops.selectPickUpPoint",
        changePickUpPoint: "uiText.parcelShops.changePickUpPoint",
    },
};

export default ShippingMethods;
